
































import { Component, Vue } from 'vue-property-decorator';
import { User } from '../../models/user.model';

@Component({})
export default class LoginPage extends Vue {
  user: User = new User();
  requiredRule = [(v: string) => !!v || this.$t('error.requiredField')];

  created(): void {
    this.$store.dispatch('account/logout');
  }

  submit(): void {
    window.location.replace('/login');
  }
}
